/* ==========================================================================
   Size guide (sections/ivp-size-guide.liquid)
   - one chart at a time: tiles, the sticky select, #hash and ?size-guide= links (outrider / crosswind -> shirts)
   - Men's / Women's per chart, cm / in for every measurement cell
   - "Find my size": reads the chart, asks for its body measurements (or the garment ones on laid-flat charts),
     picks the size ("the bigger number wins", the client's own rule) and highlights it in the table
   - the illustration lights up the measurements the selected chart uses
   Without this script every chart stays visible, stacked.
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var root = d.querySelector('[data-ivp-size-guide]');
  if (!root) return;
  function qs(s, el) { return (el || d).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  var panels = qsa('[data-sg-panel]', root);
  var tiles = qsa('[data-sg-tile]', root);
  var select = qs('[data-sg-select]', root);
  var genderSeg = qs('[data-sg-gender]', root);
  var unitSeg = qs('[data-sg-units]', root);
  var state = { panel: null, gender: 'men', unit: 'cm' };
  var ALIAS = { outrider: 'shirts', crosswind: 'shirts', vanguard: 'hoodies', valkyrie: 'leggings', sierra: 'jeans' };
  var mobile = window.matchMedia('(max-width: 899px)');

  /* ---------- Measurement keys (illustration lines and calculator labels) ---------- */
  var KEYS = [
    ['front-rise', /front\s*r[ai]+se/i], ['back-rise', /back\s*r[ai]+se/i], ['inseam', /inseam|inside leg|leg length/i],
    ['shoulder', /shoulder/i], ['chest', /chest/i], ['bust', /bust/i], ['belly', /belly/i], ['waist', /waist/i],
    ['hip', /\bhips?\b/i], ['thigh', /thigh/i], ['knee', /knee/i], ['ankle', /ankle|leg opening/i], ['cuff', /cuff/i],
    ['hem', /\bhem\b/i], ['sleeve', /sleeve/i], ['arm', /\barm\b/i], ['height', /height/i], ['length', /length/i], ['hand', /\bhand\b/i]
  ];
  // match without the bracketed detail: "Hip (19cm from waist)" is a hip measurement, not a waist one
  function keyFor(label) { var l = String(label).replace(/\([^)]*\)/g, ' '); for (var i = 0; i < KEYS.length; i++) if (KEYS[i][1].test(l)) return KEYS[i][0]; return null; }

  /* ---------- Numbers ---------- */
  function parseVal(s) {
    s = (s || '').replace(/,/g, '.').trim();
    var r = s.match(/^(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)$/);
    if (r) return { min: parseFloat(r[1]), max: parseFloat(r[2]), range: true };
    var n = s.match(/^(\d+(?:\.\d+)?)$/);
    if (n) return { min: parseFloat(n[1]), max: parseFloat(n[1]), range: false };
    return null;
  }
  function fmt(n) { return (Math.round(n * 10) / 10).toString(); }
  function toIn(cmText) {
    return cmText.replace(/\d+(?:\.\d+)?/g, function (m) { return fmt(parseFloat(m) / 2.54); });
  }

  /* ---------- Read a chart into sizes x measurements ---------- */
  function readChart(fig) {
    var table = qs('table', fig);
    if (!table || !table.rows.length) return null;
    var rows = Array.prototype.slice.call(table.rows).map(function (tr) { return Array.prototype.slice.call(tr.cells); });
    var head = rows[0].map(txt);
    var caption = qs('figcaption', fig) ? txt(qs('figcaption', fig)) : '';
    var chart = { fig: fig, table: table, sizes: [], measures: [], flat: /flat/i.test(caption + ' ' + head[0]) };
    var measureCols = [];
    head.forEach(function (h, i) { if (i > 0 && keyFor(h) && !/size/i.test(h.replace(/chest size/i, ''))) measureCols.push(i); });
    // sizes in rows when the header row names measurements (Euro | USA | Chest (cm) ...), otherwise sizes in columns
    if (measureCols.length) {
      /* sizes in rows: label columns (Euro, USA, Alpha ...) + measurement columns */
      chart.orient = 'rows';
      var labelCols = head.map(function (h, i) { return i; }).filter(function (i) { return measureCols.indexOf(i) < 0; });
      rows.slice(1).forEach(function (cells, r) {
        chart.sizes.push({ main: txt(cells[labelCols[0]] || cells[0]), extra: labelCols.slice(1).map(function (i) { return head[i] + ' ' + txt(cells[i]); }), cells: cells, row: cells[0].parentNode });
      });
      measureCols.forEach(function (i) {
        var vals = rows.slice(1).map(function (cells) { return parseVal(txt(cells[i] || { textContent: '' })); });
        chart.measures.push({ label: head[i], key: keyFor(head[i]), vals: vals, cells: rows.slice(1).map(function (c) { return c[i]; }), headCell: rows[0][i] });
      });
    } else {
      /* sizes in columns: first column holds the measurement names, some rows are other size systems */
      chart.orient = 'cols';
      head.slice(1).forEach(function (h, j) { chart.sizes.push({ main: h, extra: [], col: j + 1 }); });
      rows.slice(1).forEach(function (cells) {
        var label = txt(cells[0]);
        var vals = cells.slice(1).map(function (c) { return parseVal(txt(c)); });
        var numeric = vals.filter(Boolean).length;
        if (numeric >= Math.max(1, Math.floor(vals.length / 2)) && keyFor(label)) {
          chart.measures.push({ label: label, key: keyFor(label), vals: vals, cells: cells.slice(1), headCell: cells[0] });
        } else if (label) {
          cells.slice(1).forEach(function (c, j) { if (chart.sizes[j]) chart.sizes[j].extra.push(label + ' ' + txt(c)); });
        }
      });
    }
    var anyRange = chart.measures.some(function (m) { return m.vals.some(function (v) { return v && v.range; }); });
    chart.measures.forEach(function (m) {
      m.upto = /up to/i.test(m.label);
      m.type = m.vals.some(function (v) { return v && v.range; }) ? 'range' : (m.upto ? 'upto' : 'single');
      m.ask = !anyRange || m.type !== 'single';
    });
    chart.garment = !anyRange;
    if (chart.garment) {
      /* garment (laid flat) charts list up to eight measurements: ask only for the four that decide the size */
      var PRI = ['waist', 'chest', 'hip', 'inseam', 'sleeve', 'length', 'thigh', 'shoulder', 'hem', 'knee', 'ankle', 'cuff', 'front-rise', 'back-rise'];
      var rank = function (k) { var i = PRI.indexOf(k); return i < 0 ? 99 : i; };
      var ranked = chart.measures.filter(function (m) { return m.key; }).sort(function (a, b) { return rank(a.key) - rank(b.key); }).slice(0, 4);
      chart.measures.forEach(function (m) { m.ask = ranked.indexOf(m) > -1; });
    }
    return chart;
  }

  /* ---------- Units ---------- */
  function applyUnits(scope) {
    qsa('[data-sg-chart]', scope || root).forEach(function (fig) {
      var chart = fig._chart || (fig._chart = readChart(fig));
      if (!chart) return;
      chart.measures.forEach(function (m) {
        m.cells.forEach(function (c) {
          if (!c || !parseVal(txt(c)) && c.dataset.cm === undefined) return;
          if (c.dataset.cm === undefined) c.dataset.cm = txt(c);
          c.textContent = state.unit === 'in' ? toIn(c.dataset.cm) : c.dataset.cm;
        });
        var h = m.headCell;
        if (h) {
          if (h.dataset.label === undefined) h.dataset.label = h.innerHTML;
          h.innerHTML = state.unit === 'in' ? h.dataset.label.replace(/\(cm\)/gi, '(in)').replace(/\bcm\b/g, 'in') : h.dataset.label;
        }
      });
      var h0 = chart.table.rows[0] && chart.table.rows[0].cells[0];
      if (h0 && chart.orient === 'cols') {
        if (h0.dataset.label === undefined) h0.dataset.label = h0.innerHTML;
        h0.innerHTML = state.unit === 'in' ? h0.dataset.label.replace(/\(cm\)/gi, '(in)') : h0.dataset.label;
      }
    });
  }

  /* ---------- Calculator ---------- */
  function buildFinder(variant) {
    var box = qs('[data-sg-finder]', variant);
    if (!box || box._built) return;
    var charts = qsa('[data-sg-chart]', variant).map(function (fig) { return fig._chart || (fig._chart = readChart(fig)); })
      .filter(function (c) { return c && c.measures.some(function (m) { return m.ask; }); });
    if (!charts.length) return;
    box._built = true;
    box.hidden = false;
    var cur = 0;
    var values = {};
    box.innerHTML =
      '<div class="ivp-sg__finder-head"><p class="ivp-sg__finder-title">Find my size</p>' +
      (charts.length > 1 ? '<label class="ivp-sg__finder-chart"><span>Chart</span><select data-f-chart>' + charts.map(function (c, i) {
        var name = qs('figcaption', c.fig) ? txt(qs('figcaption', c.fig)) : txt(c.table.rows[0].cells[0]);
        return '<option value="' + i + '">' + name.replace(/</g, '&lt;') + '</option>';
      }).join('') + '</select></label>' : '') + '</div>' +
      '<p class="ivp-sg__finder-sub" data-f-sub></p><div class="ivp-sg__finder-fields" data-f-fields></div>' +
      '<div class="ivp-sg__finder-result" data-f-result aria-live="polite"></div>';
    var fields = qs('[data-f-fields]', box), result = qs('[data-f-result]', box), sub = qs('[data-f-sub]', box);

    function render() {
      var c = charts[cur];
      sub.textContent = c.garment
        ? 'Measure a piece you own that fits well, laid flat, and enter the numbers in ' + state.unit + '.'
        : 'Enter your body measurements in ' + state.unit + '. Leave any you do not know blank.';
      fields.innerHTML = c.measures.filter(function (m) { return m.ask; }).map(function (m, i) {
        var id = 'sgf-' + Math.random().toString(36).slice(2, 8) + i;
        var name = m.label.replace(/\((?:cm|in)\)/gi, '').replace(/\s*\(([^)]*)\)\s*/g, ' ').replace(/^[A-F]\s+/, '').trim();
        return '<label class="ivp-sg__field" for="' + id + '"><span>' + name + '</span><span class="ivp-sg__field-in"><input id="' + id + '" type="number" inputmode="decimal" min="0" step="any" data-f-key="' + m.label.replace(/"/g, '&quot;') + '" value="' + (values[m.label] ? fmt(state.unit === 'in' ? values[m.label] / 2.54 : values[m.label]) : '') + '"><em>' + state.unit + '</em></span></label>';
      }).join('');
      lightFigure(c);
      calc();
    }
    function calc() {
      var c = charts[cur];
      qsa('.is-match', c.table).forEach(function (el) { el.classList.remove('is-match'); });
      var pick = -1, why = null, over = null;
      c.measures.forEach(function (m) {
        var v = values[m.label];
        if (!m.ask || !v) return;
        var idx = -1;
        if (m.type === 'single') {
          var best = Infinity;
          m.vals.forEach(function (x, i) { if (x && Math.abs(x.min - v) <= best) { best = Math.abs(x.min - v); idx = i; } });
        } else {
          for (var i = 0; i < m.vals.length; i++) { var x = m.vals[i]; if (x && v <= x.max + 0.0001) { idx = i; break; } }
          if (idx < 0) over = m;
        }
        if (idx > pick) { pick = idx; why = m; }
      });
      if (over) {
        result.innerHTML = '<p class="ivp-sg__res-title">Above this chart</p><p>Your ' + over.label.replace(/\(.*?\)/g, '').trim().toLowerCase() + ' is larger than our biggest size here. Message us: leather suits and jackets can be made to your measurements.</p>' + helpLink();
        result.className = 'ivp-sg__finder-result is-over';
        return;
      }
      if (pick < 0) { result.innerHTML = ''; result.className = 'ivp-sg__finder-result'; return; }
      var size = c.sizes[pick];
      result.className = 'ivp-sg__finder-result is-on';
      result.innerHTML = '<p class="ivp-sg__res-kicker">Your size</p><p class="ivp-sg__res-size">' + size.main + '</p>' +
        (size.extra.length ? '<p class="ivp-sg__res-extra">' + size.extra.join(' · ') + '</p>' : '') +
        (why ? '<p class="ivp-sg__res-why">Set by your ' + why.label.replace(/\(.*?\)/g, '').replace(/^[A-F]\s+/, '').trim().toLowerCase() + ' (the bigger number wins).</p>' : '') + helpLink();
      if (c.orient === 'rows' && size.row) size.row.classList.add('is-match');
      if (c.orient === 'cols') {
        Array.prototype.forEach.call(c.table.rows, function (tr) { var cell = tr.cells[size.col]; if (cell) cell.classList.add('is-match'); });
        var wrap = c.table.parentNode, cell0 = c.table.rows[0].cells[size.col];
        if (wrap && cell0 && wrap.scrollWidth > wrap.clientWidth) wrap.scrollTo({ left: Math.max(0, cell0.offsetLeft - wrap.clientWidth / 2), behavior: 'smooth' });
      }
    }
    function helpLink() {
      var wa = root.getAttribute('data-wa');
      return wa ? '<a class="ivp-sg__res-help" href="' + wa + '" target="_blank" rel="noopener">Between sizes? Send us your measurements</a>' : '';
    }
    box.addEventListener('input', function (e) {
      var k = e.target.getAttribute('data-f-key');
      if (!k) return;
      var v = parseFloat(e.target.value);
      values[k] = isNaN(v) || v <= 0 ? 0 : (state.unit === 'in' ? v * 2.54 : v);
      calc();
    });
    box.addEventListener('change', function (e) { if (e.target.matches('[data-f-chart]')) { cur = parseInt(e.target.value, 10) || 0; render(); } });
    box._render = render;
    render();
  }

  /* ---------- Illustration ---------- */
  function lightFigure(chart) {
    var variant = chart.fig.closest('[data-sg-variant]');
    var wrap = qs('[data-sg-figures]', variant);
    if (!wrap) return;
    var want = chart.flat && wrap.getAttribute('data-flat') !== 'none' ? wrap.getAttribute('data-flat') : wrap.getAttribute('data-default');
    qsa('[data-sg-figure]', wrap).forEach(function (svg) { svg.classList.toggle('is-shown', svg.getAttribute('data-sg-figure') === want); });
    var keys = chart.measures.map(function (m) { return m.key; });
    qsa('[data-key]', wrap).forEach(function (g) { g.classList.toggle('is-on', keys.indexOf(g.getAttribute('data-key')) > -1); });
    qsa('[data-sg-point]', variant).forEach(function (li) { li.classList.toggle('is-on', keys.indexOf(keyFor(li.getAttribute('data-sg-point'))) > -1); });
  }

  /* ---------- Panels ---------- */
  function visibleVariant(panel) {
    var vs = qsa('[data-sg-variant]', panel);
    if (vs.length < 2) return vs[0];
    return vs.filter(function (v) { return v.getAttribute('data-sg-variant') === state.gender; })[0] || vs[0];
  }
  function show(id, opts) {
    opts = opts || {};
    var panel = panels.filter(function (p) { return p.getAttribute('data-sg-panel') === id; })[0];
    if (!panel) return;
    state.panel = id;
    panels.forEach(function (p) { p.classList.toggle('is-active', p === panel); });
    tiles.forEach(function (t) { var on = t.getAttribute('data-sg-tile') === id; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    if (select) select.value = id;
    var vs = qsa('[data-sg-variant]', panel);
    if (genderSeg) genderSeg.hidden = vs.length < 2;
    var vis = visibleVariant(panel);
    vs.forEach(function (v) { v.hidden = v !== vis; });
    if (vis) {
      buildFinder(vis);
      var f = qs('[data-sg-finder]', vis);
      if (f && f._render) f._render();
      else { var first = qs('[data-sg-chart]', vis); if (first && first._chart) lightFigure(first._chart); }
      qsa('[data-sg-mbox]', vis).forEach(function (det) { if (!det._set) { det._set = true; det.open = !mobile.matches; } });
    }
    if (opts.push !== false && history.replaceState) history.replaceState(null, '', '#' + id);
    if (opts.scroll) {
      var top = panel.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(d.documentElement).getPropertyValue('--ivp-header-bottom'), 10) || 0) - 70;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }
  function setSeg(seg, value) { qsa('button', seg).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-value') === value ? 'true' : 'false'); }); }

  tiles.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); show(t.getAttribute('data-sg-tile'), { scroll: true }); }); });
  if (select) select.addEventListener('change', function () { show(select.value, { scroll: true }); });
  if (genderSeg) genderSeg.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    state.gender = b.getAttribute('data-value'); setSeg(genderSeg, state.gender); show(state.panel, { push: false });
  });
  if (unitSeg) unitSeg.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    state.unit = b.getAttribute('data-value'); setSeg(unitSeg, state.unit); applyUnits();
    qsa('[data-sg-finder]', root).forEach(function (f) { if (f._render) f._render(); });
  });

  // #jeans-women / ?size-guide=jeans&view=women open that chart's women's view (product pages for women's gear link
  // here, 7 Oct 2026)
  function fromLocation() {
    var q = new URLSearchParams(window.location.search);
    var h = (q.get('size-guide') || window.location.hash.replace('#', '') || '').toLowerCase();
    var g = (q.get('view') || '').toLowerCase();
    var m = h.match(/^(.+)-(women|men)$/);
    if (m && !panels.some(function (x) { return x.getAttribute('data-sg-panel') === h; })) { h = m[1]; g = m[2]; }
    if (g === 'women' || g === 'men') { state.gender = g; if (genderSeg) setSeg(genderSeg, g); }
    h = ALIAS[h] || h;
    return panels.some(function (x) { return x.getAttribute('data-sg-panel') === h; }) ? h : null;
  }
  window.addEventListener('hashchange', function () { var id = fromLocation(); if (id) show(id, { push: false, scroll: true }); });

  qsa('[data-sg-hidden]', root).forEach(function (v) { v.hidden = true; });
  root.classList.add('is-ready');
  var initial = fromLocation();
  show(initial || root.getAttribute('data-default') || (panels[0] && panels[0].getAttribute('data-sg-panel')), { push: false, scroll: !!initial });
})();
